import { render, staticRenderFns } from "./ForgotPassword-v1.vue?vue&type=template&id=3747e156&scoped=true"
import script from "./ForgotPassword-v1.vue?vue&type=script&lang=js"
export * from "./ForgotPassword-v1.vue?vue&type=script&lang=js"
import style0 from "./ForgotPassword-v1.vue?vue&type=style&index=0&id=3747e156&prod&lang=scss"
import style1 from "./ForgotPassword-v1.vue?vue&type=style&index=1&id=3747e156&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3747e156",
  null
  
)

export default component.exports